/* eslint-disable */

(function ($) {
    var AjaxFilters = function (item) {
        this.$checked = item.find('.icheckbox_flat-aero.checked')

        this.init(this.$checked);
    };

    AjaxFilters.prototype.init = function (checked) {
        var allVals = $($(checked).find('input')).map(
            function () {
                var valueChecked = $(this).attr('name');
                if ($(this).hasClass('checked')) {
                    $('#choices').find("input[value='" + valueChecked + "']").attr('checked', 'checked')
                    return valueChecked;
                } else {
                    $('#choices').find("input[value='" + valueChecked + "']").removeAttr('checked')
                }
            }
        ).get().join();

        $('#txtValue').val(allVals)
    };

    $(document).on('click', '.woof_list_checkbox li', function (e) {
        e.stopImmediatePropagation();
        new AjaxFilters($('.woof_block_html_items'));
    })

    // @TODO Dev => ne marche pas pour le moment
    $(function () {

        // Met à jour le custom filtre
        if ($('.woof_block_html_items').length > 0) {

            var allVals = $($('.woof_block_html_items').find('input')).map(
                function () {
                    var valueChecked = $(this).attr('name');
                    if ($(this).hasClass('checked')) {
                        $('#choices').find("input[value='" + valueChecked + "']").attr('checked', 'checked')
                        return valueChecked;
                    } else {
                        $('#choices').find("input[value='" + valueChecked + "']").removeAttr('checked')
                    }
                }
            ).get().join();

            $('#txtValue').val(allVals)
        }
    })
})(jQuery);